import { DecimalPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, InputSignal, ModelSignal, input, model } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';

import { IconDirective } from '@core/shared/util';

@Component({
  selector: 'mp-toggle-filter',
  templateUrl: './toggle-filter.component.html',
  styleUrl: './toggle-filter.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [DecimalPipe, MatCardModule, MatIconModule, MatSlideToggleModule, IconDirective],
})
export class ToggleFilterComponent {
  readonly standalone: InputSignal<boolean> = input<boolean>(true);

  readonly checked: ModelSignal<boolean> = model.required<boolean>();

  readonly filterName: InputSignal<string> = input.required<string>();

  readonly icon: InputSignal<string | undefined> = input<string>();

  readonly showLabels: InputSignal<boolean> = input<boolean>(false);

  readonly inactiveLabel: InputSignal<string | number | undefined> = input<string | number>();

  readonly activeLabel: InputSignal<string | number | undefined> = input<string | number>();

  onToggleChange(checked?: boolean): void {
    this.checked.set(checked ?? !this.checked());
  }
}
